module.exports = __webpack_public_path__ + "img/favicon.cc3c2d28.png";